import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  value: string;
  isLast?: boolean;
}

export const CoolingPageContractDetail: FC<Props> = ({ title, value, isLast = false }) => {
  return (
    <HStack
      mb="12px"
      minH="27px"
      justifyContent="space-between"
      borderBottom={isLast ? "none" : "1px solid"}
      borderColor="gray.300"
    >
      <Text variant="brand" fontSize="12px" lineHeight="16px">{title}</Text>
      <Text variant="brand" fontSize="14px" minW="130px" textAlign="end">{value}</Text>
    </HStack>
  );
};
